import { Button, SettingsRow, SettingsSection } from '@wundo/ui';
import { AddColleagueDialog } from '@/components/meetings/AddColleagueDialog.tsx';
import type { MeetingFollowExceptionItem } from '@/lib/meetingFollow.ts';
import { m } from '@/paraglide/messages.js';

interface FollowedColleaguesSectionProps {
  /** Every one-to-one is followed already, so picking people adds nothing. */
  covered: boolean;
  /** The colleagues whose one-to-ones Wundo follows. */
  followed: readonly MeetingFollowExceptionItem[];
  /** Every standing correction, so the dialog offers nobody already in one. */
  corrections: readonly MeetingFollowExceptionItem[];
  removing: boolean;
  onRemove: (exceptionId: string) => void;
}

/*
 * Right under the kinds, because picking colleagues is the same choice
 * made person by person. The kind that covers them all hides the list
 * the way "alle gesprekken" hides the kinds it covers; the picks stay.
 */
export function FollowedColleaguesSection({
  covered,
  followed,
  corrections,
  removing,
  onRemove,
}: FollowedColleaguesSectionProps) {
  return (
    <SettingsSection
      title={m.meetings_colleagues_title()}
      description={covered ? undefined : m.meetings_colleagues_desc()}
      action={covered ? undefined : <AddColleagueDialog corrections={corrections} />}
    >
      {covered && (
        <p className='px-5.5 py-4 text-sm text-ink-muted'>
          {m.meetings_colleagues_covered()}
        </p>
      )}
      {!covered &&
        (followed.length > 0 ? (
          followed.map((colleague) => (
            <SettingsRow
              key={colleague.id}
              label={colleague.label ?? colleague.person_email}
              description={m.meetings_colleague_one_on_ones()}
            >
              <Button
                size='sm'
                variant='dangerQuiet'
                disabled={removing}
                onClick={() => onRemove(colleague.id)}
              >
                {m.meetings_exception_remove()}
              </Button>
            </SettingsRow>
          ))
        ) : (
          <p className='px-5.5 py-4 text-sm text-ink-muted'>
            {m.meetings_colleagues_empty()}
          </p>
        ))}
    </SettingsSection>
  );
}
